import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_EventsBaseTable = _resolveComponent("EventsBaseTable")!
  const _component_AddVESEventCard = _resolveComponent("AddVESEventCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_EventsBaseTable, {
      class: "dashboards-tables--export-hidden",
      title: "Мероприятия, организуемые Минэкономразвития России",
      emptyText: "Мероприятия Минэкономразвития России не запланированы",
      columns: _ctx.columns,
      storePaths: _ctx.storePaths,
      params: _ctx.tableParams,
      eventConfigs: _ctx.eventConfigs,
      updateTrigger: _ctx.updateTrigger
    }, {
      "head-actions": _withCtx(() => [
        (_ctx.editable)
          ? (_openBlock(), _createBlock(_component_ButtonComponent, {
              key: 0,
              mod: "gradient-bg",
              onClick: _ctx.openCreateModal
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Создать мероприятие ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "storePaths", "params", "eventConfigs", "updateTrigger"]),
    (_ctx.editable)
      ? (_openBlock(), _createBlock(_component_AddVESEventCard, {
          key: 0,
          modelValue: _ctx.isCreateModalOpen,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCreateModalOpen) = $event)),
            _ctx.onModalToggle
          ],
          editId: _ctx.editEventId,
          countryOptions: _ctx.partnerCountryList,
          eventTypeOptions: _ctx.eventVedTypes,
          eventStatusOptions: _ctx.eventStatuses,
          onSaved: _ctx.refreshTable
        }, null, 8, ["modelValue", "editId", "countryOptions", "eventTypeOptions", "eventStatusOptions", "onSaved", "onUpdate:modelValue"]))
      : _createCommentVNode("", true)
  ]))
}